// extracted by mini-css-extract-plugin
module.exports = {"sendInput":"Channel_sendInput__3jQQw","sendButton":"Channel_sendButton__1k_w0"};